module.exports = __webpack_public_path__ + "41b72bae860d297cc028c64a7abc01c3.pdf";